export const DATE_RANGES = ['today', '7d', '30d'] as const;
export type DateRange = (typeof DATE_RANGES)[number];

export const RANGE_DAYS: Record<DateRange, number> = {
	today: 0,
	'7d': 6,
	'30d': 29,
};

export const DISTRIBUTION_KEYS = ['1', '2', '3', '4', '5'] as const;
